export default [
	{
		name : 'Hiroki Noma',
		post : 'Founder / Managing Director',
		animal : 'lizard',
		count : 0,
		link : "https://twitter.com/HirokiNOMA"
	},
	{
		name : 'Kenta Toshikura',
		post : 'Founder / Head of Design & Development',
		animal : 'rabbit',
		count : 0,
		link : "https://twitter.com/silkhat_7"
	},
	{
		name : 'Misato Daikuhara',
		post : 'Founder / Art Director',
		animal : 'raccoon',
		count : 0,
		link : "https://twitter.com/misatodaiq"
	},
	{
		name : 'Mikiko Kikuoka',
		post : 'Designer / Developer',
		animal : 'cat',
		count : 0,
		link : "https://twitter.com/mikikokikuoka"
	},
	{
		name : 'Nobuaki Honma',
		post : 'Designer / Developer',
		animal : 'fox',
		count : 0,
		link : "https://twitter.com/NobuakiHonma"
	},
	{
		name : 'Natsuko Sakai',
		post : 'Project Manager',
		animal : 'goat',
		count : 0,
		link : "https://twitter.com/natsukosakai"
	},
	{
		name : 'Meguru Muramoto',
		post : 'Designer / Developer',
		animal : 'koala',
		count : 0,
		link : "https://twitter.com/_____1345726"
	},
	{
		name : 'HACHI',
		post : 'AI Assistant',
		animal : 'hachi',
		count : 0,
		link : "/ai/"
	}
]